import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { HeartHandshake, MapPin, Calendar, ArrowRight } from "lucide-react";

// Helper-side discovery rail. Deliberately NO instant-apply here (user
// decision, 2026-07): neighbour help deserves a review step, so the CTA
// navigates to the full request detail — read everything, message the
// requester, then offer (behind the safety prompt) from there.
export const NearbyHelp = () => {
  const [items, setItems] = useState([]);

  useEffect(() => { api.nearbyHelp().then(setItems).catch(() => setItems([])); }, []);

  if (items.length === 0) return null;

  return (
    <div data-testid="nearby-help-card" className="mt-6 bg-sky-50 border border-sky-200 rounded-2xl p-6">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="text-xs uppercase tracking-[0.18em] text-sky-800 font-bold flex items-center gap-1.5">
          <HeartHandshake className="w-4 h-4" /> Neighbours near you need a hand
        </div>
        <Link to="/opportunities?type=help" data-testid="nearby-help-see-all" className="text-xs text-sky-700 font-medium hover:underline">
          See all help requests
        </Link>
      </div>
      <div className="mt-4 space-y-2.5">
        {items.map((o) => (
          <div key={o.id} data-testid={`nearby-help-${o.id}`} className="bg-white border border-sky-100 rounded-xl p-4 flex items-center gap-3 flex-wrap">
            <div className="flex-1 min-w-[180px]">
              <Link to={`/opportunities/${o.id}`} className="font-medium text-forest text-sm hover:underline">{o.title}</Link>
              <div className="text-xs text-neutral-500 mt-1 flex items-center gap-2.5 flex-wrap">
                <span>{o.org_name}</span>
                <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3" />{o.distance_miles} mi</span>
                {o.event_date && (
                  <span className="inline-flex items-center gap-1"><Calendar className="w-3 h-3" />{new Date(o.event_date).toLocaleDateString()}</span>
                )}
              </div>
            </div>
            <Link
              to={`/opportunities/${o.id}`}
              data-testid={`nearby-help-view-${o.id}`}
              className="text-xs font-medium px-4 py-2 rounded-full bg-sky-600 text-white hover:bg-sky-700 transition-colors shrink-0 inline-flex items-center gap-1.5"
            >
              View request <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
